import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HeaderService } from './headers/header.service';
import { IAuth } from '../open-age/core/services/auth.interface';
import { RoleService } from '../open-age/core/services';
import { EncryptionDecryptionService } from './encryptDecrypt/encryption-decryption.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private encryptDecryptService: EncryptionDecryptionService;
  constructor(
    private http: HttpClient,
    private header: HeaderService,
    private role: RoleService
  ) {
    this.encryptDecryptService = new EncryptionDecryptionService();
  }

  get(url: string, isDecrypt?: boolean): Observable<any> {
    const subject = new Subject<any>();
    this.http.get(url, { headers: this.header.getHeaders() }).subscribe(async (res: any) => {
      const isSuccess = res.isSuccess !== undefined ? res.isSuccess : (res as any).IsSuccess;
      if (!isSuccess) {
        const error = new Error(res.error || res.code || res.message || 'failed');
        return this.handleError(error, subject);
      }
      else {
        if (isDecrypt) {
          try {
            await this.encryptDecryptService.decrypt(res.message).then((response) => {
              res.data = JSON.parse(response);
            });
          } catch (error) {
            console.error('Error decrypting items:', error);
            throw new Error('Failed to decrypt response items');
          }
        }
        subject.next(res);
      }
    }, (e) => {
      return this.handleError(e, subject);
    });
    return subject.asObservable();
  }

  post(url: string, params: any, isDecrypt?: boolean): Observable<any> {
    const subject = new Subject<any>();
    this.http.post(url, params, { headers: this.header.getHeaders() }).subscribe(async (res: any) => {
      const isSuccess = res.isSuccess !== undefined ? res.isSuccess : (res as any).IsSuccess;
      if (!isSuccess) {
        const error = new Error(res.error || res.code || res.message || 'failed');
        return this.handleError(error, subject);
      }
      else {
        if (isDecrypt) {
          try {
            await this.encryptDecryptService.decrypt(res.message).then((response) => {
              res.data = JSON.parse(response);
            });
          } catch (error) {
            console.error('Error decrypting items:', error);
            throw new Error('Failed to decrypt response items');
          }
        }
        subject.next(res);
      }
    }, (e) => {
      return this.handleError(e, subject);
    });
    return subject.asObservable();
  }

  put(url: string, params: any, isDecrypt?: boolean): Observable<any> {
    const subject = new Subject<any>();
    this.http.put(url, params, { headers: this.header.getHeaders() }).subscribe(async (res: any) => {

      if (isDecrypt) {
        try {
          await this.encryptDecryptService.decrypt(res.message).then((response) => {
            res.data = JSON.parse(response);
          });
        } catch (error) {
          console.error('Error decrypting items:', error);
          throw new Error('Failed to decrypt response items');
        }
      }
      subject.next(res);
    }, (e) => {
      return this.handleError(e, subject);
    });
    return subject.asObservable();
  }


  handleError(err: any, subject: Subject<any>) {
    let isLogout = false

    if (err.error) {
      if (err.error.error == "INVALID_DEVICE" || err.error.error == "SESSION_EXPIRED" || err.error.message == "INVALID_DEVICE" || err.error.message == "SESSION_EXPIRED" || err.error.code == "INVALID_DEVICE" || err.error.code == "SESSION_EXPIRED") {
        isLogout = true
      }
    }

    let error = err.error && (err.error.error || err.error.message || err.error.code) ? (err.error.error || err.error.message || err.error.code) : err.message || err;
    if (typeof error == "object") {

      if (error.error) {
        error = error.error
      }

      if (error.message) {
        error = error.message
      }

      if (error.code) {
        error = error.code
      }
    }

    if (!error) {
      error = 'Oops! Something went wrong. Please try again.'
    }

    subject.error(error);
    if (isLogout) {
      this.role.logout()
    }
  }
}
